import React, { useEffect, useState } from "react";
import MainLayout from "../../components/layout";
import { role, token_leads, token_user } from "../../../../helpers/auth";
import { PremiumLayoutSkeleton } from "../../../../components/page-skeleton";
import { useHistory } from "react-router-dom";
import { Button, Card } from "antd";
import Cookie from "js-cookie";

const SignupSuccess = () => {
  const history = useHistory();
  const [isAuthenicated, setAuthenicated] = useState(true);

  useEffect(() => {
    const expirationTimestamp = localStorage.getItem("expirationTimestamp");
    if (expirationTimestamp && Date.now() > parseInt(expirationTimestamp, 10)) {
      Object.keys(Cookie.get()).forEach((cookieName) => {
        Cookie.remove(cookieName);
      });
      setAuthenicated(false);
    } else if (role === "leads" && token_leads) {
      history.replace("/leads");
    } else if (role === "user" && token_user) {
      history.replace("/home");
    } else {
      setAuthenicated(false);
    }
    localStorage.removeItem("expirationTimestamp");
  }, []);

  if (isAuthenicated)
    return (
      <div className="loading-screen">
        <PremiumLayoutSkeleton />
      </div>
    );

  return (
    <MainLayout>
      <Card className="signup-action-wrapper">
        <h1>Congratulations!</h1>
        <p>
          You have successfully registered as a <b>Professional</b> user. Login
          to your account to start using the platform.
        </p>
        <Button
          type="primary"
          onClick={() => history.push("/")}
          className="action-btn"
        >
          Login
        </Button>
      </Card>
    </MainLayout>
  );
};

export default SignupSuccess;
